import type { PropsWithChildren } from 'react';

import styles from './Attention.module.css';

import { Icon } from 'components/Icon';

/** Shows the ExclamationCircleFillMini icon with children */
export const Attention = ({ children }: PropsWithChildren) => (
  <div className={styles['attention']}>
    <Icon name="ExclamationCircleFillMini" size={24} />
    {children}
  </div>
);
